// VideoPlayer.jsx
import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon } from '@heroicons/react/outline';
import ReactPlayer from 'react-player';

import './VideoPlayer.css';

import VideoQuestions from './VideoQuestions';

const VideoPlayer = ({ video, onBack }) => {
  const [videoId, setVideoId] = useState(null);
  const [playedPercentage, setPlayedPercentage] = useState(0);
  const playerRef = useRef(null);

  useEffect(() => {
    const extractedId = extractVideoId(video.url);
    setVideoId(extractedId);
  }, [video.url]);

  const extractVideoId = url => {
    const regExp =
      /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[1].length === 11 ? match[1] : null;
  };

  const handleProgress = state => {
    setPlayedPercentage(state.played * 100);
  };

  return (
    <div className="video-player-page min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <button
            onClick={onBack}
            className="flex items-center text-gray-600 hover:text-gray-800 transition-colors duration-200 focus:outline-none"
            aria-label="Back to Gallery"
          >
            <ChevronLeftIcon className="h-6 w-6 mr-2" />
            <span className="font-medium">Volver a Galería</span>
          </button>
          {/* Optional: Add additional header elements here */}
        </div>
      </header>

      {/* Video Player */}
      <main className="flex-grow container mx-auto px-4 py-6 flex flex-col items-center justify-center">
        <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg overflow-hidden mx-auto">
          <div className="player-wrapper">
            <ReactPlayer
              ref={playerRef}
              url={video.url}
              controls
              className="react-player"
              width="100%"
              height="100%"
              onProgress={handleProgress}
            />
          </div>
          <div className="p-4">
            <h2 className="text-lg font-semibold text-gray-800 text-center">
              {video.title}
            </h2>
          </div>
        </div>

        {/* Video Questions */}
        {videoId && playedPercentage >= 90 && (
          <div className="mt-8 w-full max-w-10xl">
            <VideoQuestions videoId={videoId} />
          </div>
        )}
      </main>
    </div>
  );
};

export default VideoPlayer;
